import { render, staticRenderFns } from "./vpd-change-password-panel.vue?vue&type=template&id=3a6f0f26&scoped=true"
import script from "./vpd-change-password-panel.vue?vue&type=script&lang=js"
export * from "./vpd-change-password-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6f0f26",
  null
  
)

export default component.exports